import reactStringReplace from "react-string-replace";

export default function (value) {
  let text = "";
  
  if (typeof value !== "string") {
    if (value.retweeted_status) {
      if (value.retweeted_status.extended_tweet) {
        text = "RT @" + value.retweeted_status.user.screen_name + ": " + value.retweeted_status.extended_tweet.full_text
      } else {
        text = "RT @" + value.retweeted_status.user.screen_name + ": " + value.retweeted_status.text
      }
    } else if (value.extended_tweet) {
      text = value.extended_tweet.full_text;
    } else {
      text = value.text;
    }  
  } else {
    text = value;
  }

  const patterns = {
    "&lt;": "<",
    "&gt;": ">",
    "&amp;": "&",
    "&quot;": '"',
    "&#x27;": "'",
    "&#x60;": "`",
  };

  // アンエスケープ処理
  const unescapeText = text.replace(/&(lt|gt|amp|quot|#x27|#x60);/g, (match) => {
    return patterns[match];
  });

  let replacedText = reactStringReplace(
    unescapeText,
    /(https?:\/\/\S+)/g,
    (match, i) => (
      <a key={match + i} href={match} target="_blank" rel="noopener noreferrer">
        {match}
      </a>
    )
  );

  replacedText = reactStringReplace(replacedText, /@(\w+)/g, (match, i) => (
    <>
      <a key={match + i} href={`https://twitter.com/${match}`} target="_blank" rel="noopener noreferrer">
        @{match}
      </a>
      <span> </span>
    </>
  ));

  replacedText = reactStringReplace(replacedText, /#(.+?)\s/g, (match, i) => (
    <>
      <a key={match + i} href={`https://twitter.com/hashtag/${match}`} target="_blank" rel="noopener noreferrer">
        #{match}
      </a>
      <span> </span>
    </>
  ));

  return replacedText;
}
